export default class MathHelper {

  static isNumeric(mixed_var) {
    return (typeof(mixed_var) === 'number' || typeof(mixed_var) === 'string') && mixed_var !== '' && !isNaN(mixed_var);
  }

  static isNumberFloat(n) {
    return this.isNumeric(n) && n % 1 !== 0;
  }
  static deg2rad(angle) {
    return  (angle * Math.PI) / 180;
  }


  static currencyFormat(num, decimals) {
    num = parseFloat(num);
    if(isNaN(decimals)) {
      decimals = 2;
    }
    return (
      num
        .toFixed(decimals) // always two decimal digits
        .replace('.', ',') // replace decimal point character with ,
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
    ) // use . as a separator
  }

}